import { IsString, IsNotEmpty, IsUUID } from 'class-validator';

import { NOT_EMPTY_OPTIONS } from '../../constants';

export class ReturnEventDto {
  @IsNotEmpty()
  @IsUUID()
  eventId: string;

  @IsNotEmpty()
  @IsUUID()
  nodeId: string;

  @IsNotEmpty({
    ...NOT_EMPTY_OPTIONS,
    groups: ['form'],
  })
  @IsString({
    ...NOT_EMPTY_OPTIONS,
    groups: ['form'],
  })
  comment: string;
}
